import { call, put, takeLatest, takeEvery } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../../services/apis";

export function* handleFetchPendingOrderReport({ payload }) {
  try {
    const res = yield call(API.fetchPaymentReport, payload);
    const { data } = res;
    yield put(actions.fetchPendingOrderReportSuccess(data));
  } catch (err) {
    yield put(actions.fetchPendingOrderReportFailure(err?.response?.data));
  }
}

export function* handleSendPaymentReminder({ payload }) {
  try {
    const res = yield call(API.sendPaymentReminder, payload);
    const { data } = res;

    yield put(actions.sendReminderSuccess({ id: payload.id, data }));
    if (payload.onSuccess) {
      payload.onSuccess();
    }
  } catch (err) {
    yield put(
      actions.sendReminderFailure({
        error: err?.response?.data,
        id: payload.id,
      })
    );
    payload.onFailure();
  }
}

export function* handleFetchPaymentPendingOrders({ payload }) {
  try {
    const res = yield call(API.fetchPendingPaymentOrders, payload);
    const { data } = res;
    yield put(actions.fetchPaymentPendingOrdersSuccess(data));
  } catch (err) {
    yield put(actions.fetchPaymentPendingOrdersFailure(err?.response?.data));
  }
}
/**
 * Root saga manages watcher lifecycle
 */
export function* orderListingSaga() {
  yield takeLatest(
    actions.fetchPendingOrderReport.type,
    handleFetchPendingOrderReport
  );
  yield takeLatest(
    actions.fetchPaymentPendingOrders.type,
    handleFetchPaymentPendingOrders
  );
  yield takeEvery(actions.sendReminder.type, handleSendPaymentReminder);
}
